import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import ScreeningPage from './pages/ScreeningPage';
import ProcessPage from './pages/ProcessPage';

// Light routing without react-router: /process is the Stripe-return page,
// everything else is the upload + screen page. Keeps deps minimal.
function Router() {
  const isProcess = window.location.pathname.startsWith('/process');
  return isProcess ? <ProcessPage /> : <ScreeningPage />;
}

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1a1a2e' }, // StrixScreener dark
    success: { main: '#10b981' },
    warning: { main: '#f59e0b' },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  },
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none', fontWeight: 600 },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
  );
}
